import { Component } from '@angular/core';

@Component({
  selector: 'plc-connected-arrow',
  templateUrl: './connected-arrow.component.html',
  styleUrls: ['./connected-arrow.component.scss']
})
export class ConnectedArrowComponent {
}
